import { type FC, type Dispatch, type SetStateAction } from 'react';
import PayByEWay from '../Payment/PayByEWay';
import { type EwayAccessCode } from '@/api/registration/payment';

interface EWayPaymentProps {
  isValid: boolean
  setErrors: Dispatch<SetStateAction<string[]>>
  options: EwayAccessCode
}

const EWayPayment: FC<EWayPaymentProps> = ({ isValid, setErrors, options }) => {
  return (
    <PayByEWay
      isValid={isValid}
      setErrors={setErrors}
      options={options}
    />
  );
};

export default EWayPayment;
